import { Preview } from 'screens/VirtualMarketerOnboarding/Preview/Preview'
import { usePreviewState } from '../PreviewProvider/PreviewProvider'

const PersistedPreview = ({ showShuffleButton, size }: { showShuffleButton: boolean; size?: 'normal' | 'small' }) => {
  const { showPreview, brandKit, colors, fontStyles, media } = usePreviewState()

  if (!showPreview || !brandKit) return null

  return (
    <Preview
      brandKit={brandKit}
      colors={colors}
      fontStyles={fontStyles}
      media={media}
      showShuffleButton={showShuffleButton}
      size={size}
    />
  )
}

export default PersistedPreview
